import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ae800ce")

_pushScopeId("data-v-5ae800ce")
const _hoisted_1 = {
  key: 0,
  class: "select-list-filter"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")

  return (_openBlock(), _createBlock("ul", null, [
    (_ctx.filterable)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.filterValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterValue = $event)),
            placeholder: _ctx.$wordList.LogInHtmlSearch,
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredList, (item) => {
      return (_openBlock(), _createBlock("li", {
        onClick: ($event: any) => (_ctx.choose(item)),
        class: _ctx.active == item.key ? 'active' : '',
        key: item.key
      }, _toDisplayString(item.label), 11, ["onClick"]))
    }), 128))
  ]))
})